import { useEffect, useState } from "react";
import { fetchHouseBanks, downloadHouseBanksExcel } from "../Api/ViewHouseBank";
import { Container, Table, Button } from "react-bootstrap";

import { toast } from "react-toastify";
import moment from "moment";
import { useAuth } from "../Context/AuthContext";
const ViewHouseBank = () => {
  const [houseBanks, setHouseBanks] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const {user}=useAuth();
  useEffect(() => {
    const loadHouseBanks = async () => {
      try {
        const data = await fetchHouseBanks(user?.organisationId);
        setHouseBanks(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching House Banks`);
      }
    };

    loadHouseBanks();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadHouseBanksExcel();
      
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'House_Banks_Data.xlsx');
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);
      
      toast.success("House banks data download started!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      
        <div className="">
          <Container className="list-container">
           <div className="header-background">
              <h2 className="header-list-title">View House Banks</h2>
              <Button className="gradient-btn"
                // variant="primary" 
                onClick={handleDownload}
                disabled={isDownloading || houseBanks.length === 0}
              >
                {isDownloading ? 'Downloading...' : 'Download Data'}
              </Button>
            </div>

            {houseBanks.length > 0 ? (
              <Table bordered hover responsive className="data-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Account Number</th>
                    <th>Bank Name</th>
                    <th>Customer ID</th>
                    <th>IFSC Code</th>
                    <th>Account Opening Date</th>
                    <th>Created On</th>
                    <th>Created By</th>
                    <th>Changed On</th>
                    <th>Changed By</th>
                  </tr>
                </thead>
                <tbody>
                  {houseBanks.map((bank, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{bank.accountNumber}</td>
                      <td>{bank.bankName}</td>
                      <td>{bank.customerId}</td>
                      <td>{bank.ifscCode}</td>
                      <td>{moment(bank.accountOpeningDate).format('L')}</td>
                      <td>
                        {moment(bank.createdOnDate).format('L')} at {bank.createdOnTime?.substring(0, 8)}
                      </td>
                      <td>{bank.createdBy}</td>
                      <td>
                        {bank.changedOnDate ? 
                          `${moment(bank.changedOnDate).format('L')} at ${bank.changedOnTime?.substring(0, 8)}` : 
                          'N/A'}
                      </td>
                      <td>{bank.changedBy || 'N/A'}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p className="no-data">No house banks found.</p>
            )}
          </Container>
        </div>
      
    </>
  );
};

export default ViewHouseBank;